// extracted by mini-css-extract-plugin
export default {"imageWrapper":"GC-z","twoColumnImage":"HC-z"};